import axios from "axios";
import { useEffect, useState } from "react";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const img = (u) => (!u ? "" : u.startsWith("http") ? u : `${BACKEND}${u}`);

const fmt = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" });
export const eur = (n) => fmt.format(Number(n || 0));

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

const cache = {};
const load = (url) =>
  (cache[url] ||= api.get(url).then((r) => r.data).catch((e) => {
    delete cache[url];
    throw e;
  }));

export function useRemote(url) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let on = true;
    load(url).then((d) => on && setData(d)).catch(() => on && setData(undefined));
    return () => {
      on = false;
    };
  }, [url]);
  return data;
}

export const useCategories = () => useRemote("/categories");
export const useSettings = () => useRemote("/settings/public");

export const isFreeShipping = (p) => p.shipping_type === "FREE_SHIPPING" || p.shipping_required === false;
export const inStock = (p) => !p.inventory_tracked || p.quantity > 0;
